export default __webpack_public_path__ + "images/bc21dd374ebf9a353cc9f2bbe4938459-spirits_small.webp";